import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../Auth/context/AuthContext';

import BlogListPage from '../BlogListPage.jsx';

import {
  deletePortfolio,
  loadPortfolio,
  loadUserPortfolios,
  portfolioExists,
  renamePortfolio,
  savePortfolio,
  rebuildVisibility,
} from '../../utilities/Portfolios/publishedPortfolioUtils';

const PublishedListPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [userId, setUserId] = useState(null);
  const [syncingVisibility, setSyncingVisibility] = useState(false);
  const [syncMessage, setSyncMessage] = useState(null);

  useEffect(() => {
    if (user) {
      setUserId(user.uid);
    } else {
      const redirectPath = encodeURIComponent(`${window.location.pathname}${window.location.search}${window.location.hash}`);
      navigate(`/login?redirectPath=${redirectPath}`);
    }
  }, [user, navigate]);

  const handleRebuildVisibility = async () => {
    if (!userId) {
      return;
    }

    setSyncingVisibility(true);
    setSyncMessage(null);

    try {
      await rebuildVisibility(userId);
      setSyncMessage('Your published portfolio list is up to date.');
    } catch (error) {
      console.error('Error rebuilding visibility:', error);
      setSyncMessage('We could not refresh the published list. Please try again.');
    } finally {
      setSyncingVisibility(false);
    }
  };

  return (
    <>
      {syncMessage ? (
        <div className="alert alert-info py-2" role="alert">
          <small>{syncMessage}</small>
        </div>
      ) : null}
      <BlogListPage
        type={"Published"}
        path={`/${userId}/published`}
        userId={userId}
        loadPortfolio={loadPortfolio}
        loadPortfolios={loadUserPortfolios}
        deletePortfolio={deletePortfolio}
        portfolioExists={portfolioExists}
        savePortfolio={savePortfolio}
        renamePortfolio={renamePortfolio}
        allowedActions={['View', 'Publish', 'CopyLink']}
        createAllowed={false}
      />
      <div className="mb-2 text-center">
        <p className="text-muted me-1">Recently published or removed portfolios not showing correctly? Refresh the published list.</p>
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={handleRebuildVisibility}
          disabled={!userId || syncingVisibility}
        >
          {syncingVisibility ? 'Refreshing...' : 'Refresh Published List'}
        </button>
      </div>

    </>
  )
}

export default PublishedListPage;
